/**
 * FitTrack Coach Brand Logo
 * Uses the exact user-provided logo:
 * - /logo192.png: Icon only (F + dumbbell + clipboard)
 * - /logo-full.png: Full logo with "FitTrack COACH" text
 */

export const BrandIcon = ({ size = "w-10 h-10", className = "" }) => (
  <img 
    src="/logo192.png" 
    alt="FitTrack Coach" 
    className={`${size} rounded-lg object-contain flex-shrink-0 ${className}`}
  />
);

export const BrandText = ({ className = "" }) => (
  <span className={`font-heading font-extrabold tracking-widest ${className}`}>
    <span className="text-white">FitTrack </span>
    <span className="bg-gradient-to-r from-[#00E5FF] to-[#3B82F6] bg-clip-text text-transparent uppercase">COACH</span>
  </span>
);

export const BrandFull = ({ iconSize = "w-10 h-10", textSize = "text-lg" }) => (
  <div className="flex items-center gap-3">
    <BrandIcon size={iconSize} />
    <BrandText className={textSize} />
  </div>
);

export const BrandLogoFull = ({ className = "h-28" }) => (
  <img 
    src="/logo-full.png" 
    alt="FitTrack Coach" 
    className={`${className} object-contain`}
  />
);
